// src/components/ai/WelcomeScreen.js
import { useState } from 'react';
import { BsSend } from 'react-icons/bs';

export default function WelcomeScreen({ onSend }) {
  const [query, setQuery] = useState('');

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (query.trim()) onSend(query);
  };

  return (
    <div className="relative flex flex-col items-center justify-center h-full px-4 text-center overflow-hidden bg-gradient-to-t from-purple-800 via-blue-800 via-teal-800 to-white">
      {/* محتوای روی گرادینت */}
      <div className="relative z-10 flex flex-col items-center justify-center w-full max-w-lg">
        <h1
          className="text-3xl font-extrabold text-white mb-3 drop-shadow-lg"
          style={{ fontFamily: 'Doran, sans-serif' }}
        >
          دستیار هوشمند فرزانه
        </h1>
        <p className="text-sm text-white/90 max-w-md mb-8 leading-relaxed drop-shadow-md">
          همراه شما در ژرف‌کاوی آثار و اندیشه‌های استاد مصطفی ملکیان.
          <br />
          بپرسید تا با هم بیاموزیم...
        </p>

        {/* کادر ورودی شیشه‌ای بدون بردر */}
        <div className="w-full backdrop-blur-xl bg-white/10 rounded-2xl p-4">
          <textarea
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault();
                handleSubmit();
              }
            }}
            placeholder="پرسش خود را بنویسید..."
            rows={2}
            className="w-full min-h-[56px] px-3 py-2 bg-transparent border-none outline-none text-sm resize-none text-white placeholder:text-white/50"
            style={{ fontFamily: 'Doran, sans-serif' }}
          />
          <div className="flex justify-end mt-2">
            <button
              onClick={handleSubmit}
              disabled={!query.trim()}
              className={`flex items-center justify-center w-10 h-10 rounded-xl transition-all duration-300 ${
                query.trim()
                  ? 'bg-purple-600 hover:bg-purple-700 text-white shadow-lg shadow-purple-200/30 active:scale-95'
                  : 'bg-gray-500/50 text-gray-300 cursor-not-allowed'
              }`}
            >
              <BsSend size={16} />
            </button>
          </div>
        </div>

        <p className="text-xs text-white/60 mt-4">
          Enter برای ارسال &nbsp;·&nbsp; Shift+Enter برای خط جدید
        </p>
      </div>
    </div>
  );
}